<template>

  <v-card :style="{maxWidth: '400px'}" variant="flat">
    <v-card-title style="text-wrap-mode: wrap;">

      <div class="d-flex justify-space-between mb-2">
        <div style="line-height: 1.3">{{ title }}</div>
        <div v-if="$slots.tools" class="ml-4">
          <slot name="tools" />
        </div>
      </div>

    </v-card-title>
    <v-card-text>

      <slot />

    </v-card-text>
  </v-card>

</template>

<script setup lang="ts">

interface Props {
  title: string
}

defineProps<Props>()

</script>
